import { Apis } from "libs/apis";

export const useBulkIngredients = () => {
    const uploadBulkIngredients = async (formData: FormData) => {
        try {
            const response = await Apis.uploadBulkIngredients(formData);
            return response;
        } catch (error) {
            console.error('Error uploading bulk ingredients:', error);
        }
    }

    const generateCsvForIngredients = async () => {
        try {
            const response = await Apis.generateCsvForIngredients();
            
            // Detect file type from Content-Type header
            const contentType = response.headers['content-type'] || response.headers['Content-Type'] || '';
            let blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            let fileName = 'ingredients-template.csv.xlsx';

            // Check if it's an XLSX file
            if (contentType.includes('spreadsheetml') || 
                contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
                contentType.includes('application/vnd.ms-excel')) {
                blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                fileName = 'ingredients-template.csv.xlsx';
            } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
                blobType = 'text/csv';
                fileName = 'ingredients-template.csv';
            }

            // response.data is already a Blob when responseType: 'blob' is set
            const arrayBuffer = await response.data.arrayBuffer();
            
            // Create blob with detected type
            const blob = new Blob([arrayBuffer], { type: blobType });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            return response;
        } catch (error: any) {
            console.error('Error generating CSV for ingredients:', error);
            throw error;
        }
    }

    return { uploadBulkIngredients, generateCsvForIngredients };
}